var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("d2-container", [
    _c(
      "div",
      { staticStyle: { padding: "20px" } },
      [
        _c(
          "el-tabs",
          {
            model: {
              value: _vm.activeName,
              callback: function($$v) {
                _vm.activeName = $$v
              },
              expression: "activeName"
            }
          },
          [
            _c("el-tab-pane", { attrs: { label: "系统报表", name: "0" } }, [
              _c("div", { staticStyle: { height: "70vh" } }, [_c("sr1")], 1)
            ]),
            _c("el-tab-pane", { attrs: { label: "派系报表", name: "1" } }, [
              _c("div", { staticStyle: { height: "70vh" } }, [_c("sr2")], 1)
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }